import {
  MilestonesSummary,
  PhasesSummary,
  ProjectsReportRecord,
  TasksSummary,
} from 'components/organisms/projects-report/types';
import {
  ApiPhaseForProjectsReport,
  ApiProjectsReport,
  ApiTaskForProjectsReport,
} from './api-types';

const getPhasesSummary = (
  phase?: ApiPhaseForProjectsReport,
): PhasesSummary | undefined =>
  phase != null
    ? {
        count: phase.phaseCount,
        completedOnTimeCount: phase.phaseCompletedOnTimeCount,
        completedLateCount: phase.phaseCompletedLateCount,
      }
    : undefined;

const getTasksSummary = (
  task?: ApiTaskForProjectsReport,
): TasksSummary | undefined =>
  task?.task != null ? { ...task.task } : undefined;

const getMilestonesSummary = (
  task?: ApiTaskForProjectsReport,
): MilestonesSummary | undefined =>
  task?.milestone != null ? { ...task.milestone } : undefined;

export const asProjectsReport = (
  report: ApiProjectsReport,
): ProjectsReportRecord[] => {
  return report.projectReports.map(
    ({
      task,
      phase,
      template,
      budgetedHours,
      totalTrackedHours,
      trackedDifference,
      allocationInfo,
      ...rest
    }) => ({
      ...rest,
      template:
        template.templateId && template.templateName
          ? {
              templateId: template.templateId,
              templateName: template.templateName,
            }
          : undefined,
      budgetedHours,
      totalTrackedHours,
      hoursDifference: trackedDifference,
      phasesSummary: getPhasesSummary(phase),
      tasksSummary: getTasksSummary(task),
      milestonesSummary: getMilestonesSummary(task),
      allocationInfo:
        allocationInfo == null
          ? {
              minutes: 0,
            }
          : {
              minutes: allocationInfo.minutes,
            },
    }),
  );
};
